import { Component, OnInit, ViewEncapsulation, Input, NgZone, OnDestroy } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { FormGroup, FormBuilder, Validators, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { Router } from '@angular/router';
import { TranslatorService } from '../../../core/translator/translator.service';
import { promise } from 'protractor';
import { Subscription } from 'rxjs';
import { MeteorUserProfile, SexType } from '../../../../../../backend/server/data-models/meteor-user/meteor-user';
import { UserService } from '../../user/user.service';
import { settings } from 'cluster';


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RegisterComponent implements OnInit, OnDestroy {

  // Datepicker
  bsValue = new Date();
  bsRangeValue: Date[];
  maxDate = new Date();
  bsConfig = {
    containerClass: 'theme-angle'
  }


  valForm: FormGroup;
  passwordForm: FormGroup;

  selectedLanguage: string;

  alreadyExistEmail: Promise<boolean>

  langs: Promise<{ code: string, text: string }[]>;
  langsSubscription: Subscription;

  constructor(
    public settings: SettingsService,
    fb: FormBuilder,
    public ngZone: NgZone,
    public router: Router,
    public translator: TranslatorService,
    public userService: UserService
  ) {
    this.langsSubscription = this.translator.availableLangs.subscribe(langs => this.langs = Promise.resolve(langs));
    this.selectedLanguage = this.translator.useLanguage();

    let password = new FormControl('', Validators.compose([Validators.required, Validators.pattern('^(?=.*[a-z])(?=.*[A-Z]).{6,60}$')]));
    let certainPassword = new FormControl('', [Validators.required, CustomValidators.equalTo(password), Validators.pattern('^(?=.*[a-z])(?=.*[A-Z]).{6,60}$')]);

    this.passwordForm = fb.group({
      'password': password,
      'confirmPassword': certainPassword
    });

    this.valForm = fb.group({
      'email': [null, Validators.compose([Validators.required, CustomValidators.email])],
      'accountagreed': [null, Validators.required],
      'passwordGroup': this.passwordForm,
      'lastName': [null, Validators.required],
      'firstName': [null, Validators.required],
      'displayName': [null, Validators.required],
      'birthday': [null, [Validators.required, CheckBirthDate]],
      'sex': [null, Validators.required],
      'title': [''],
      'lang': [this.selectedLanguage]
    });
  }

  ngOnInit() {
  }

  async submitForm($ev, value: any) {
    $ev.preventDefault();
    for (let c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }
    for (let c in this.passwordForm.controls) {
      this.passwordForm.controls[c].markAsTouched();
    }

    if (this.valForm.valid) {
      this.alreadyExistEmail = new Promise((resolve, reject) => {
        this.register(async err => {
          if (!err) {
            this.ngZone.run(() => this.router.navigate(['login'])).then();
            resolve(false);
          }
          else {
            if (err.error == 403) {
              this.userService.addRole("USER");
              resolve(true);
            }
          }
        });
      })
    }
  }

  ngOnDestroy() {
    if (this.langsSubscription) this.langsSubscription.unsubscribe();
  }


  updateDisplayNameField() {
    const langHU = this.valForm.value.lang === "hu";
    const lastName = this.valForm.value.lastName;
    const firstName = this.valForm.value.firstName;
    const title = this.valForm.value.title;
    let displayName = this.valForm.value.displayName;

    // console.warn("updateDisplayNameField - " + langHU); console.warn(this.valForm.value);

    if (lastName && firstName && !displayName) {

      displayName = langHU ? lastName + ' ' + firstName : firstName + " " + lastName;
      if (title) {
        displayName = langHU ? displayName + " " + title : title + " " + displayName;
      }

      this.valForm.controls['displayName'].patchValue(displayName)
      this.valForm.controls['displayName'].markAsTouched()
    }
  }

  register(callback?: (err: any) => void) {

    let sex = this.valForm.controls['sex'].value === "option1"
      ? SexType.Female
      : this.valForm.controls['sex'].value === "option2"
        ? SexType.Male
        : null;

    const user: { // -> Accounts.createUser(options,...)
      username?: string,
      email?: string,
      password?: string,
      profile?: MeteorUserProfile
    } = {
      username: this.valForm.controls['email'].value,
      email: this.valForm.controls['email'].value,
      password: this.passwordForm.controls['password'].value,
      profile: {
        firstName: this.valForm.controls['firstName'].value,
        lastName: this.valForm.controls['lastName'].value,
        title: this.valForm.controls['title'].value,
        displayName: this.valForm.controls['displayName'].value,
        birthday: this.valForm.controls['birthday'].value,
        sex: sex,
        lang: this.valForm.controls['lang'].value,
        layout: this.settings.createDefaultLayout()
      }
    };

    Accounts.createUser(user, callback);
  }

  setLang(event) {
    this.translator.useLanguage(this.valForm.controls["lang"].value);
    this.valForm.controls["displayName"].patchValue("");
    this.updateDisplayNameField();

    this.settings.setUserSetting("lang", this.valForm.controls["lang"].value);

  }

  isValidBirthDate() {
    if (this.valForm.controls['birthday'].errors != null) {
      if (this.valForm.controls['birthday'].errors.err != null) {
        return true
      }
    }
    return false
  }
}

function CheckBirthDate(control: AbstractControl): { [key: string]: boolean } | null {

  var today = new Date();
  if (control.value != undefined) {

    if (control.value != null && new Date(control.value) > today) {
      return { 'err': true }
    }
  }

  return null
}